import {Formik, useFormikContext} from "formik";
import {toJS} from "mobx";
import {observer} from "mobx-react-lite";
import React, {useContext, useEffect, useState} from "react";
import {useHistory, useParams} from "react-router-dom";
import {TextInput} from "../../../app/common/input-text";
import {ExchangeFormValues} from "../../../app/models/exchange-types";
import {Store} from "../../../app/stores/store-root";
import CurrencySelector from "./currencies-selector";
import {Currency} from "../../../app/models/currency";
import {schema} from "./exchange-rate-form-validation";
import {EuiFieldNumber} from "@elastic/eui";

const ExchangeRateForm = () => {
    const {id} = useParams();
    const [exchange, setExchange] = useState(new ExchangeFormValues());
    const [isEdit, setIsEdit] = useState(false);
    const [error, setError] = useState(undefined);
    const store = useContext(Store);
    const {loadLookups, currencyRegistry, lookupLoaded} = store.Lookups;
    const {loadExchange, createExchangeRate, saveExchangeRate} = store.Exchanges;
    const history = useHistory();
    const formik = useFormikContext();
    const onFromChanged = (code: string) => {
        console.log(code);
        var currency: Currency|undefined = store.Lookups.currencyRegistry.find(item=>item.code===code);
        console.log(currency);
        var newFormValues: ExchangeFormValues = new ExchangeFormValues(exchange);
        newFormValues.From = currency!.label;
        newFormValues.FromCode = code;
        newFormValues.FromSymbol = currency!.symbol;
        newFormValues.Label = `From ${currency!.label} to ${exchange.To} `
        newFormValues.Id = `From_${currency!.code}_to_${exchange.ToCode}`
        setExchange(newFormValues);
    }
    const onToChanged = (code: string) => {
        var currency: Currency|undefined = store.Lookups.currencyRegistry.find(item=>item.code===code);
        console.log("To ", currency);
        var newFormValues: ExchangeFormValues = new ExchangeFormValues(exchange);
        newFormValues.To = currency!.label;
        newFormValues.ToCode = code;
        newFormValues.ToSymbol = currency!.symbol;
        newFormValues.Label = `From ${exchange.From} to ${currency!.label} `
        newFormValues.Id = `From_${exchange.FromCode}_to_${currency!.code}`
        setExchange(newFormValues);
    }

    useEffect(() => {
        const loadLookup = async () => await loadLookups();

        const loadData = async (id: string) => {
            const result = await loadExchange(id);
            return result;
        };
        if (id) setIsEdit(true);

        loadLookup().catch((e) => {
            console.log("Exchange-Form.tsx : problems loading lookup :  ", error);
            setError(e);
        });

        if (isEdit)
            loadData(id)
                .then((exchange) => {
                    console.log("To be edited", exchange);
                    setExchange(new ExchangeFormValues(exchange));
                })
                .catch((e) => {
                    console.log(
                        "exchange-Form.tsx : problems loading exchange :  ",
                        error
                    );
                    setError(e);
                });
    }, [id, isEdit]);

    const onSubmit = (values: ExchangeFormValues) => {
        if (isEdit) {
            console.log("Editing ", values);
            saveExchangeRate(values).then(() => {
                history.push('/rates');
                //store.Modal.openModal('Welcome');
            }).catch((e) => {
                console.log("Error " + JSON.stringify(e.response.data));
            })

        } else {
            console.log("New ", values);

            createExchangeRate(values).then(() => {
                history.push('/rates');
               // store.Modal.openModal('Welcome');
            }).catch((e) => {
                console.log("Error " + JSON.stringify(e.response.data));
            });


        }
    };


    return (
        <Formik
            initialValues={exchange}
            onSubmit={(values) => {
                onSubmit(values);
            }}
            validationSchema={schema}
            enableReinitialize={true}
        >
            {(formik) => (
                <form onSubmit={formik.handleSubmit}>
                    {
                        (lookupLoaded) ?
                            <div className="mt-6 bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6">
                                <div className="md:grid md:grid-cols-3 md:gap-6">
                                    <div className="md:col-span-1">
                                        <h3 className="text-lg font-medium leading-6 text-gray-900">
                                            Allowed Currency Exchanges
                                        </h3>
                                        <p className="mt-1 text-sm leading-5 text-gray-600">
                                            Lorem ipsum dolor sit amet consectetur, adipisicing elit. Hic
                                            numquam, vero molestias deleniti ducimus temporibus odit
                                            voluptatibus perspiciatis harum sequi architecto nulla at
                                            excepturi laudantium ipsam? Esse inventore quidem culpa?
                                        </p>
                                    </div>
                                    <div className="mt-5 md:mt-0 md:col-span-2">
                                        <div className="grid grid-cols-2 gap-6">
                                            <div className="col-span-4 sm:col-span-2">
                                                <label
                                                    htmlFor="name"
                                                    className="block text-sm font-medium leading-5 text-gray-700"
                                                >
                                                    From
                                                </label>
                                                <div className="w-1/2">
                                                    <CurrencySelector id="FromCode" name="FromCode"
                                                                      options={store.Lookups.currencies}
                                                                      label={'Select From Currency'}
                                                                      onChange={onFromChanged} disabled={isEdit}/>
                                                </div>
                                            </div>
                                            <div className="col-span-4 sm:col-span-2">
                                                <label
                                                    htmlFor="name"
                                                    className="block text-sm font-medium leading-5 text-gray-700"
                                                >
                                                    To
                                                </label>
                                                <div className="w-1/2">
                                                    <CurrencySelector id="ToCode" name="ToCode"
                                                                      options={store.Lookups.currencies}
                                                                      label={'Select To Currency'}
                                                                      onChange={onToChanged} disabled={isEdit}/>
                                                </div>
                                            </div>
                                            <div className="col-span-4 sm:col-span-2">
                                                <label
                                                    htmlFor="name"
                                                    className="block text-sm font-medium leading-5 text-gray-700"
                                                >
                                                    Exchange Rate
                                                </label>
                                                <div className="w-1/2">
                                                    <EuiFieldNumber {...formik.getFieldProps('ExchangeRate')} ></EuiFieldNumber>
{/*
                                                    <TextInput id="ExchangeRate" placeholder="0.0" disabled={false}/>
*/}
                                                </div>
                                            </div>
                                            <div className="col-span-4 sm:col-span-2">
                                                <label
                                                    htmlFor="name"
                                                    className="block text-sm font-medium leading-5 text-gray-700"
                                                >
                                                    Sabbur Rate
                                                </label>
                                                <div className="w-1/2">
                                                    <EuiFieldNumber {...formik.getFieldProps('AgencyRate')} ></EuiFieldNumber>
                                                    {/*
                                                    <TextInput id="ExchangeRate" placeholder="0.0" disabled={false}/>
*/}
                                                </div>
                                            </div>
                                            <div className="col-span-4 sm:col-span-2">
                                                <label
                                                    htmlFor="name"
                                                    className="block text-sm font-medium leading-5 text-gray-700"
                                                >
                                                    Currency Exchange ID (Admin use)
                                                </label>
                                                <div className="w-1/2">
                                                    <TextInput id='Id' placeholder={'Automatically filled'}
                                                               disabled={true}/>
                                                </div>
                                            </div>
                                            <div className="col-span-4 sm:col-span-2">
                                                <label
                                                    htmlFor="name"
                                                    className="block text-sm font-medium leading-5 text-gray-700"
                                                >
                                                    Currency Exchange Label
                                                </label>
                                                <div className="w-1/2">
                                                    <TextInput id='Label' placeholder={'Automatically filled'}
                                                               disabled={true}/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="px-4 py-3 bg-gray-50 space-x-4 text-right sm:px-6">
                                     <span className="inline-flex rounded-md shadow-sm">
              <button
                  type="button"
                  onClick={() => history.push('/rates')}
                  className="inline-flex justify-center py-2 px-4 border border-transparent text-sm leading-5 font-medium rounded-md text-gray-900 border-gray-600 bg-white hover:bg-white focus:outline-none focus:border-white focus:shadow-outline-indigo active:bg-white transition duration-150 ease-in-out"
              >
                Cancel
              </button>
            </span>

              <span className="inline-flex rounded-md shadow-sm">
                <button
                    type="submit"
                    className="inline-flex justify-center py-2 px-4 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition duration-150 ease-in-out"
                >
                  Save
                </button>
              </span>

                                </div>
                            </div> : ""
                    }
                </form>
            )}
        </Formik>
    );
};

export default observer(ExchangeRateForm);
